const loginManage = {
  state: {
    handleType: 'sign-in'
  },

  mutations: {
    SET_HANDLETYPE(state, handleType) {
      state.handleType = handleType
    }
  }
}

export default loginManage
